<template>
  <v-container fluid
               class="justify-center">
    <v-row justify="center">
      <v-col cols="12"
             md="6"
             class="pa-3">
        <VueOnGeoEditForm :form="forms[0]"></VueOnGeoEditForm>
      </v-col>
    </v-row>
    <VueOnGeoOkDialog :dialog="dialog"></VueOnGeoOkDialog>
  </v-container>
</template>

<script>
import axios from "axios";
import VueOnGeoOkDialog from "./vue-ongeo-ok-dialog.vue";
import VueOnGeoDialogsMixin from "./vue-ongeo-dialogs-mixin.js";
import VueOnGeoEditForm from "./vue-ongeo-edit-form.vue";

export default {
  name: "vue-ongeo-edit-profile",
  mixins: [VueOnGeoDialogsMixin],
  components: { VueOnGeoEditForm, VueOnGeoOkDialog },
  props: { url: { type: String, required: true } },
  data: () => ({
    companyInfo: {},
    emailRule: v => /.+@.+/.test(v) || "E-mail musi być poprawny"
  }),
  computed: {
    forms: function () {
      return [
        {
          title: "Edycja danych firmy",
          inputs: [
            this.createTextInput(
              "name",
              "Nazwa firmy",
              null,
              false,
              this.companyInfo
            ),
            this.createTextInput(
              "nip",
              "NIP firmy",
              null,
              false,
              this.companyInfo
            ),
            this.createTextInput(
              "street",
              "Ulica",
              null,
              false,
              this.companyInfo
            ),
            this.createTextInput(
              "streetNumber",
              "Nr domu/mieszkania",
              null,
              false,
              this.companyInfo
            ),
            this.createTextInput(
              "city",
              "Miasto",
              null,
              false,
              this.companyInfo
            ),
            this.createTextInput(
              "zipCode",
              "Kod pocztowy",
              null,
              false,
              this.companyInfo
            )
          ],
          submit: { text: "Zapisz zmiany", click: this.editData }
        }
      ];
    }
  },
  methods: {
    createTextInput: function (name, label, rules, isPassword, obj) {
      var defaultRules = [v => !!v || "Pole " + label + " jest wymagane"];
      var r = rules ? rules.concat(defaultRules) : defaultRules;
      return {
        name: name,
        label: label,
        required: true,
        rules: r,
        type: isPassword ? "password" : "text",
        value: obj[name]
      };
    },
    createPasswordInput: function (name, label) {
      return this.createTextInput(name, label, null, true);
    },
    onSuccessResponse (response) {
      if (response && response.data) {
        this.companyInfo = response.data;
        this.dialog.callback = null;
        this.dialog.text = "Dane zostały zapisane.";
      } else {
        this.onErrorResponse({ response: response });
      }
      this.dialog.show = true;
    },

    editData (form) {
      var merged = Object.assign({}, this.companyInfo, form);
      axios
        .put(this.url, merged)
        .then(this.onSuccessResponse)
        .catch(this.onErrorResponse);
    }
  },
  created: function () {
    axios.get(this.url).then(response => {
      if (response && response.data) {
        this.companyInfo = response.data;
      }
    });
  }
};
</script>
